import './PropertyContent.css'
import React, { useRef, useEffect, useState, useCallback } from 'react';
import bulb from '../assets/bulb.svg'
import people from "../assets/people.svg";
import help from "../assets/help-circle.svg"
import sidewalk_buildings from "../assets/sidewalk-buildings.svg"
import sidewalk_foreground from "../assets/sidewalk-foreground.svg"
import BasicTable from "./Table";


let CommaNumber = new Intl.NumberFormat('en-US', {
    roundingMode: 'halfCeil',
    maximumFractionDigits: 1
});


export default function PropertyContent(props) {
    const m_conversion = 3.28084;

    const rows_insights = [
    createData(props.parcel['flood_depth_1aep']['column_disp_name'], `${CommaNumber.format(props.parcel['flood_depth_1aep']['value'] * m_conversion)} ft`, props.parcel['flood_depth_1aep']['column_desc']),
    createData(props.parcel['driver_id']['column_disp_name'], props.parcel['driver_id']['value'], props.parcel['driver_id']['column_desc']),
    createData(props.parcel['aep_1ft']['column_disp_name'], `${CommaNumber.format(props.parcel['aep_1ft']['value'])}%`, props.parcel['aep_1ft']['column_desc']),
];

    const rows_property = [
      createData(props.parcel['property_value']['column_disp_name'], `$${CommaNumber.format(props.parcel['property_value']['value'])}`, props.parcel['property_value']['column_desc']),
      createData(props.parcel['fema_class_id']['column_disp_name'], props.parcel['fema_class_id']['value'], props.parcel['fema_class_id']['column_desc']),
      createData(props.parcel['land_use_class']['column_disp_name'], props.parcel['land_use_class']['value'], props.parcel['land_use_class']['column_desc']),
    ];

    function toBlue(e) {
        e.target.style.color = '#0d6efd';
    }

    function get_scaled_flood_height(floodDepth){
        return ( ((8 + (floodDepth * 8 ))*0.601).toString().concat('px') )
    }

    function toBlack(e) {
        e.target.style.color = 'black';
    }

    function createData(name, value, desc) {
        return {name: name, value: value, desc: desc};
    }


    return (
            <div className='content' data-testid="causecontent-test">
                <div className='insights-section'>
                    <div className='header1'>
                        <img src={bulb} className='icon'></img>Zeppelin Insights
                    </div>
                    <div className='flood-depth-section'>
                            <div className='header2'>
                                1% Annual Chance Flood Depth
                            </div>
                                <div className='svg-positioning'>
                                    <div className="svg-sizing">
                                        <img src={sidewalk_buildings} className='buildings'></img>
                                        <div className='floodWater' style={{ height: get_scaled_flood_height(props.parcel['flood_depth_1aep']['value'] * m_conversion)}}></div>
                                        <img src={sidewalk_foreground} className='foreground'></img>
                                    </div>
                                </div>
                            <div>
                                Predicted Flood Depth: {CommaNumber.format(props.parcel['flood_depth_1aep']['value'] * m_conversion)} ft above street level in a <a onMouseEnter={toBlue} onMouseLeave={toBlack} href='#About-flood' className="link">1% annual chance flood.</a>
                                <br/> <br/>
                                <a onMouseEnter={toBlue} onMouseLeave={toBlack} href='#About-fema' className="link">{props.parcel['fema_class_id']['column_disp_name']} : {props.parcel['fema_class_id']['value']}</a>
                                <br/><br/>
                                {(props.parcel['fema_class_id']['insurance_required'] ) && "Lenders are likely to require flood insurance for mortgages at this address"}
                                {(!props.parcel['fema_class_id']['insurance_required']) && "Lenders are unlikely to require flood insurance for mortgages at this address"}
                            </div>
                    </div>
                    <div className="prop-insights-table">
                        <BasicTable content={rows_insights}></BasicTable>
                    </div>
                </div>
                <div className='property-section'>
                    <div className='header1'>
                        <img src={people} className='icon'></img>Property Profile
                    </div>
                    <div>
                        <BasicTable content={rows_property}></BasicTable>
                    </div>
                </div>
                <div className="About-section">
                    <div className='header1'>
                            <img src={help} className='icon'></img>About
                    </div>
                    <div id="About-flood">
                        <div className='header2'>
                            1% Annual Chance Flood
                        </div>
                        A 1%-annual-chance flood has a 1% chance of occurring any given year. During the span of a 30-year mortgage, a home in the 1%-annual-chance floodplain has a 26% chance of flooding at least once during those years.
                    </div>
                    <div id="About-fema">
                        <div className='header2'>
                            FEMA Zones
                        </div>
                        {props.parcel['fema_class_id']['column_disp_name']} {props.parcel['fema_class_id']['value']} : {props.parcel['fema_class_id']['column_desc']}
                        <br/> <br/>
                        {(props.parcel['fema_class_id']['insurance_required'] ) && "Lenders are likely to require flood insurance for mortgages at this address"}
                        {(!props.parcel['fema_class_id']['insurance_required']) && "Lenders are unlikely to require flood insurance for mortgages at this address"}
                    </div>
                </div>

            </div>
    )
}